import React, { useState } from "react";
import Productcards from "../Products/Productcards";
import Header from "../Header/Header";
import Cartpopups from "../Products/Cartpopups";
import CartSlider from "../Category/CardSlider";
import "../Category/ProductPage.css";

const products = [
  {
    id: 1,
    name: "Product 1",
    price: 100,
    image: "/s1.webp",
    description: "Description of Product 1",
  },
  {
    id: 2,
    name: "Product 2",
    price: 200,
    image: "/s2.webp",
    description: "Description of Product 2",
  },
  {
    id: 3,
    name: "Product 3",
    price: 150,
    image: "/s3.webp",
    description: "Description of Product 3",
  },
  {
    id: 4,
    name: "Product 4",
    price: 250,
    image: "/s1.webp",
    description: "Description of Product 4",
  },
  {
    id: 5,
    name: "Product 5",
    price: 300,
    image: "/s2.webp",
    description: "Description of Product 5",
  },
  {
    id: 6,
    name: "Product 3",
    price: 150,
    image: "/s3.webp",
    description: "Description of Product 3",
  },
  {
    id: 7,
    name: "Product 4",
    price: 250,
    image: "/s1.webp",
    description: "Description of Product 4",
  },
  {
    id: 8,
    name: "Product 5",
    price: 300,
    image: "/s2.webp",
    description: "Description of Product 5",
  },
];

const ProductGrids = () => {
  const [columns, setColumns] = useState(1);
  const [cart, setCart] = useState([]);
  const [popupProduct, setPopupProduct] = useState(null);
  const [isCartOpen, setIsCartOpen] = useState(false);

  const toggleCart = () => setIsCartOpen(!isCartOpen);

  const addToCart = (product) => {
    const existing = cart.find((item) => item.id === product.id);
    if (existing) {
      setCart(
        cart.map((item) =>
          item.id === product.id
            ? { ...item, quantity: item.quantity + 1 }
            : item,
        ),
      );
    } else {
      setCart([...cart, { ...product, quantity: 1 }]);
    }
    setPopupProduct(product);
  };

  const updateCart = (productId, quantity) => {
    if (quantity < 1) {
      removeFromCart(productId);
    } else {
      setCart(
        cart.map((item) =>
          item.id === productId ? { ...item, quantity } : item,
        ),
      );
    }
  };

  const removeFromCart = (productId) =>
    setCart(cart.filter((item) => item.id !== productId));

  const visibleProducts = products.slice(0, columns * 4);

  const toggleView = () => {
    if (columns * 4 >= products.length) {
      setColumns(1); // Reset to 1 column if all are visible
    } else {
      setColumns((prev) => prev + 1); // Add one more column
    }
  };

  return (
    <>
      <Header
        cartCount={cart.reduce((total, item) => total + item.quantity, 0)}
        toggleCart={toggleCart}
      />
      <div className="full-p">
        <h1 className="g-h">Value For Money - Great Discounts Available</h1>
        <div className="product-gridd">
          {visibleProducts.map((product) => (
            <Productcards
              key={product.id}
              product={product}
              addToCart={addToCart}
            />
          ))}
        </div>
        <button className="view-btn" onClick={toggleView}>
          {columns * 4 >= products.length ? "View Less" : "View More"}
        </button>
      </div>
      {/* Render CartPopup only if popupProduct is set */}

      {popupProduct && (
        <Cartpopups
          product={{
            ...popupProduct,
            quantity:
              cart.find((item) => item.id === popupProduct.id)?.quantity || 1,
          }}
          onClose={() => setPopupProduct(null)}
          updateCart={updateCart}
        />
      )}

      {/* Render CartSlider for cart items */}
      <CartSlider
        cart={cart}
        isOpen={isCartOpen}
        onClose={toggleCart}
        updateCart={updateCart}
        removeFromCart={removeFromCart}
      />
    </>
  );
};

export default ProductGrids;
